import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDSpNbsGiftResponse implements ICommand
{

	public ReturnCode : number = 0;
	public UUID : string = "";
	public HostID : number = 0;
	public GiftID : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.ReturnCode = ba.readUint53();
		this.UUID = ba.readString();
		this.HostID = ba.readUint16();
		this.GiftID = ba.readUint53();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint53(this.ReturnCode);
		ba.writeString(this.UUID);
		ba.writeUint16(this.HostID);
		ba.writeUint53(this.GiftID);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDSpNbsGiftResponse();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'ReturnCode(Q)='+this.ReturnCode+' ';
		str += 'UUID(S)='+this.UUID+' ';
		str += 'HostID(W)='+this.HostID+' ';
		str += 'GiftID(Q)='+this.GiftID+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 50137;
	}

	public getCmdName() : string
	{
		return 'SpNbsGiftResponse';
	}

}
